module.exports = __webpack_public_path__ + "img/BI_6.158a3c74.png";